import script from "./smdcCard.vue?vue&type=script&setup=true&lang=js"
export * from "./smdcCard.vue?vue&type=script&setup=true&lang=js"

import "./smdcCard.vue?vue&type=style&index=0&id=d3f8d934&lang=scss"

const __exports__ = script;

export default __exports__